import React from 'react';
import { Divider, Grid, Container } from '@material-ui/core';
import { useStyles } from './styles';
import { Typography, Tabs, Tab, Icon } from '@material-ui/core';
import { SlaughterPreOrders } from '../../components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import PreDeliveryDeclarationForm from './PreDeliveryDeclarationForm';

const SlaughterPreparation: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { option } = useParams<{ option: string }>();

  const handleTabChange = (value: number) => {
    switch (value) {
      case 0:
        navigate('/slaughter-declarations/create');
        break;
      case 1:
        navigate('/slaughter-declarations/history');
        break;
      default:
        break;
    }
  };

  const getTabIndex = (): number => {
    if (option && option === 'create') {
      return 0;
    }
    if (option && option === 'history') {
      return 1;
    }
    return 0;
  };

  React.useEffect(() => {
    const tabIndex = getTabIndex();
    setTab(tabIndex);
  }, [option]);

  const [tab, setTab] = React.useState(getTabIndex());

  const handleDeclarationSaved = () => {
    // Switch to history tab after successful save
    handleTabChange(1);
  };

  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item container md={4} xs={12} spacing={1}>
              <Grid item>
                <Icon fontSize="large" color="primary">
                  {'pending_actions'}
                </Icon>
              </Grid>
              <Grid item>
                <Typography component="h2" variant="h6" color="primary">
                  {t('f-slaughter-declarations')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container direction="column" className={classes.mt1}>
            <Tabs
              value={tab}
              onChange={(_, value) => handleTabChange(value)}
              TabIndicatorProps={{ style: { height: 3 } }}
            >
              <Tab label={t('f-slaughter-declaration-create')} id="createTab" style={{ textTransform: 'none' }} />
              <Tab label={t('f-slaughter-declaration-history')} id="historyTab" style={{ textTransform: 'none' }} />
            </Tabs>
            <Divider />
          </Grid>

          <Grid container className={classes.mt3}>
            {tab === 0 && (
              <Grid item xs={12} md={12}>
                <PreDeliveryDeclarationForm onSaveSuccess={handleDeclarationSaved} />
              </Grid>
            )}
            {tab === 1 && (
              <Grid item xs={12} md={12}>
                <SlaughterPreOrders />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SlaughterPreparation;
